module.exports = __webpack_public_path__ + "static/media/wehire_x1.fda65991.png";